import BaseController from 'Controllers/User/_BaseController';

global.Controller = new class extends BaseController {

    ready() {
        super.ready();
    }

}
